// Effects (§11.19): vignette, grain, split toning — also used by the Simple-mode filters.
import { Slider } from '../controls/Slider';
import { useActive } from './useActive';
import { useT, type MessageKey } from '../../i18n';
import type { Effects } from '../../model/types';

type Row<G extends keyof Effects> = {
  group: G;
  key: keyof Effects[G];
  label: MessageKey;
  min: number;
  max: number;
  def: number;
};
const ROWS: (Row<'vignette'> | Row<'grain'> | Row<'splitTone'>)[] = [
  { group: 'vignette', key: 'amount', label: 'vignetteAmount', min: -100, max: 100, def: 0 },
  { group: 'vignette', key: 'midpoint', label: 'vignetteMidpoint', min: 0, max: 100, def: 50 },
  { group: 'vignette', key: 'feather', label: 'vignetteFeather', min: 0, max: 100, def: 50 },
  { group: 'grain', key: 'amount', label: 'grainAmount', min: 0, max: 100, def: 0 },
  { group: 'grain', key: 'size', label: 'grainSize', min: 0, max: 100, def: 25 },
  { group: 'splitTone', key: 'shadowHue', label: 'stShadowHue', min: 0, max: 360, def: 220 },
  { group: 'splitTone', key: 'shadowSat', label: 'stShadowSat', min: 0, max: 100, def: 0 },
  { group: 'splitTone', key: 'highlightHue', label: 'stHighlightHue', min: 0, max: 360, def: 40 },
  { group: 'splitTone', key: 'highlightSat', label: 'stHighlightSat', min: 0, max: 100, def: 0 },
  { group: 'splitTone', key: 'balance', label: 'stBalance', min: -100, max: 100, def: 0 },
];
const HEAD: Record<keyof Effects, MessageKey> = {
  vignette: 'vignette',
  grain: 'grain',
  splitTone: 'splitTone',
};

export function EffectsPanel() {
  const t = useT();
  const { settings, update } = useActive();
  return (
    <div>
      {ROWS.map((r, i) => (
        <div key={`${r.group}.${String(r.key)}`}>
          {(i === 0 || ROWS[i - 1]!.group !== r.group) && (
            <h4 style={{ margin: '8px 0 4px', fontSize: 12 }}>{t(HEAD[r.group])}</h4>
          )}
          <Slider
            label={r.label}
            testId={`slider-${r.group}-${String(r.key)}`}
            value={(settings.effects[r.group] as Record<string, number>)[r.key as string]!}
            min={r.min}
            max={r.max}
            step={1}
            defaultValue={r.def}
            onChange={(v, f) =>
              update((s) => void ((s.effects[r.group] as Record<string, number>)[r.key as string] = v), f)
            }
          />
        </div>
      ))}
    </div>
  );
}
